import { useEffect, useRef } from "react";
import { useTracker } from "@ferrivia/auth-web";
import { UpdatePrompt, useAppUpdate } from "@ferrivia/ui";

const CURRENT_VERSION = import.meta.env.VITE_APP_VERSION;

export function UpdateBanner() {
  const tracker = useTracker();
  const { updateAvailable, latestVersion, apply, dismiss } = useAppUpdate({
    currentVersion: CURRENT_VERSION,
    onApply: () => location.reload(),
  });
  const shownFor = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (updateAvailable && latestVersion && shownFor.current !== latestVersion) {
      shownFor.current = latestVersion;
      tracker.track("app.update_prompt_shown", {
        from_version: CURRENT_VERSION ?? "dev",
        to_version: latestVersion,
      });
    }
  }, [updateAvailable, latestVersion, tracker]);

  if (!updateAvailable || !latestVersion) return null;

  function handleApply() {
    tracker.track("app.update_applied", {
      from_version: CURRENT_VERSION ?? "dev",
      to_version: latestVersion!,
    });
    apply();
  }

  function handleDismiss() {
    tracker.track("app.update_dismissed", {
      from_version: CURRENT_VERSION ?? "dev",
      to_version: latestVersion!,
    });
    dismiss();
  }

  return <UpdatePrompt onApply={handleApply} onDismiss={handleDismiss} />;
}
